import { createSlice } from "@reduxjs/toolkit";
import { IReviewBooking } from "./reviewbookingModel";
import {
  confirmFlightBooking,
  createPaymentOrder,
  // getConfirmFlightBooking,
  getGroupwiseTravellerByUserID,
  getAirlineReprice,
  saveFlightBooking,
  saveTempFlightBooking,
  verifyPayment,
  flightTempBooking,
  addPayment,
  getSeatMap,
  getSSRList,
  getHandlingFees,
  getPromoCodeDetails,
  getChargesByMembershipPlan,
  reedemGiftCodeForBooking,
  verifyGiftCodeOtp,
} from "./services/reviewbooking.services";
// import { DUMMY_REVIEWFLIGHTDETAILS } from "../../_constants/constant";

const initialState: IReviewBooking = {
  loading: false,
  seatmapLoading: false,
  handlingFeesLoading: false,
  promoapplyLoading: false,
  giftcodeapplyLoading: false,
  ssrLoading: false,
  ssrData: null,
  travellerLoading: false,
  paymentLoading: false,
  bookingLoading: false,
  error: "",
  flightReviewDetails: null,
  handlingFees: {
    International_Cancellation_Fee: null,
    International_Conv_Fee: null,
    Domestic_Cancellation_Fee: null,
    Domestic_Conv_Fee: null,
    GSTPer: null,
  },
  adminCharges: {
    InternationalFlightCharge: null,
    DomesticFlightCharge: null,
    PlanName: "",
    ID: null,
  },
  PromoDetails: null,
  seatmapData: null,
  tabIndex: 1,
  passangerMealIndex: 0,
  passangerBaggageIndex: 0,
  passangerWheelChairIndex: 0,
  reviewBookingDetails: {
    adults: [
      {
        initial: "",
        first_name: "",
        last_name: "",
        gender: "",
        mobile_no: "",
        email_id: "",
        isSelected: true,
        date_of_birth: "",
        passport_no: "",
        issue_country_code: "",
        // issue_date: "",
        expire_date: "",
      },
    ],
    children: [
      {
        initial: "",
        first_name: "",
        last_name: "",
        gender: "",
        isSelected: true,
        date_of_birth: "",
        passport_no: "",
        issue_country_code: "",
        // issue_date: "",
        expire_date: "",
      },
    ],
    infants: [
      {
        initial: "",
        isSelected: true,
        first_name: "",
        last_name: "",
        gender: "",
        date_of_birth: "",
        passport_no: "",
        issue_country_code: "",
        // issue_date: "",
        expire_date: "",
      },
    ],
    mobile_no: "",
    email_id: "",
    // alt_mobile_no: "",
    // alt_email_id: "",
    isGST: false,
    gst_number: "",
    // gst_email: "",
    gst_registered_name: "",
    // gst_mobile: "",
    gst_address: "",
    state_id: "",
  },
};

const reviewbookingSlice = createSlice({
  name: "reviewbooking",
  initialState,
  reducers: {
    settabIndex: (state, action) => {
      state.tabIndex = action.payload;
    },
    setPassangerMealIndex: (state, action) => {
      state.passangerMealIndex = action.payload;
    },
    setPassangerBaggageIndex: (state, action) => {
      state.passangerBaggageIndex = action.payload;
    },
    setPassangerWheelChairIndex: (state, action) => {
      state.passangerWheelChairIndex = action.payload;
    },
    setFlightReviewDetails: (state, action) => {
      state.flightReviewDetails = action.payload;
    },
    clearFlightReviewDetails: (state) => {
      state.flightReviewDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAirlineReprice.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAirlineReprice.fulfilled, (state, action) => {
      state.loading = false;
      state.flightReviewDetails = action.payload?.AirRepriceResponses;
      // state.flightReviewSearchKey = action.payload?.;
      // state.flightReviewDetails = DUMMY_REVIEWFLIGHTDETAILS?.AirRepriceResponses;
    });
    builder.addCase(getAirlineReprice.rejected, (state, action) => {
      state.loading = false;
      state.flightReviewDetails = initialState.flightReviewDetails;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getSeatMap.pending, (state) => {
      state.seatmapLoading = true;
      state.error = "";
    });
    builder.addCase(getSeatMap.fulfilled, (state, action) => {
      state.seatmapLoading = false;
      state.seatmapData = action.payload;
    });
    builder.addCase(getSeatMap.rejected, (state, action) => {
      state.seatmapLoading = false;
      state.seatmapData = [];
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getSSRList.pending, (state) => {
      state.ssrLoading = true;
      state.error = "";
    });
    builder.addCase(getSSRList.fulfilled, (state, action) => {
      state.ssrLoading = false;
      state.ssrData = action.payload;
    });
    builder.addCase(getSSRList.rejected, (state, action) => {
      state.ssrLoading = false;
      state.ssrData = [];
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(confirmFlightBooking.pending, (state) => {
      state.bookingLoading = true;
      state.error = "";
    });
    builder.addCase(confirmFlightBooking.fulfilled, (state, action) => {
      state.bookingLoading = false;
    });
    builder.addCase(confirmFlightBooking.rejected, (state, action) => {
      state.bookingLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    // builder.addCase(getConfirmFlightBooking.pending, (state) => {
    //   state.bookingLoading = true;
    //   state.error = "";
    // });
    // builder.addCase(getConfirmFlightBooking.fulfilled, (state, action) => {
    //   state.bookingLoading = false;
    // });
    // builder.addCase(getConfirmFlightBooking.rejected, (state, action) => {
    //   state.bookingLoading = false;
    //   state.error = action.error.message || "Something went wrong";
    // });
    builder.addCase(saveFlightBooking.pending, (state) => {
      state.bookingLoading = true;
      state.error = "";
    });
    builder.addCase(saveFlightBooking.fulfilled, (state, action) => {
      state.bookingLoading = false;
    });
    builder.addCase(saveFlightBooking.rejected, (state, action) => {
      state.bookingLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(saveTempFlightBooking.pending, (state) => {
      state.bookingLoading = true;
      state.error = "";
    });
    builder.addCase(saveTempFlightBooking.fulfilled, (state, action) => {
      state.bookingLoading = false;
    });
    builder.addCase(saveTempFlightBooking.rejected, (state, action) => {
      state.bookingLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(flightTempBooking.pending, (state) => {
      state.bookingLoading = true;
      state.error = "";
    });
    builder.addCase(flightTempBooking.fulfilled, (state, action) => {
      state.bookingLoading = false;
    });
    builder.addCase(flightTempBooking.rejected, (state, action) => {
      state.bookingLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(addPayment.pending, (state) => {
      state.bookingLoading = true;
      state.error = "";
    });
    builder.addCase(addPayment.fulfilled, (state, action) => {
      state.bookingLoading = false;
    });
    builder.addCase(addPayment.rejected, (state, action) => {
      state.bookingLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(createPaymentOrder.pending, (state) => {
      state.paymentLoading = true;
      state.error = "";
    });
    builder.addCase(createPaymentOrder.fulfilled, (state, action) => {
      state.paymentLoading = false;
    });
    builder.addCase(createPaymentOrder.rejected, (state, action) => {
      state.paymentLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(verifyPayment.pending, (state) => {
      state.paymentLoading = true;
      state.error = "";
    });
    builder.addCase(verifyPayment.fulfilled, (state, action) => {
      state.paymentLoading = false;
    });
    builder.addCase(verifyPayment.rejected, (state, action) => {
      state.paymentLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getGroupwiseTravellerByUserID.pending, (state) => {
      state.travellerLoading = true;
      state.error = "";
    });
    builder.addCase(
      getGroupwiseTravellerByUserID.fulfilled,
      (state, action) => {
        state.travellerLoading = false;
        state.reviewBookingDetails = {
          ...state.reviewBookingDetails,
          adults:
            action.payload?.adults?.length > 0
              ? action.payload?.adults
              : state.reviewBookingDetails?.adults,
          children:
            action.payload?.children?.length > 0
              ? action.payload?.children
              : state.reviewBookingDetails?.children,
          infants:
            action.payload?.infants?.length > 0
              ? action.payload?.infants
              : state.reviewBookingDetails?.infants,
        };
      }
    );
    builder.addCase(getGroupwiseTravellerByUserID.rejected, (state, action) => {
      state.travellerLoading = false;
      state.reviewBookingDetails = initialState.reviewBookingDetails;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getHandlingFees.pending, (state) => {
      state.handlingFeesLoading = true;
      state.error = "";
    });
    builder.addCase(getHandlingFees.fulfilled, (state, action: any) => {
      state.handlingFeesLoading = false;
      state.handlingFees = action.payload;
    });
    builder.addCase(getHandlingFees.rejected, (state, action) => {
      state.handlingFeesLoading = false;
      state.handlingFees = initialState.handlingFees;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getChargesByMembershipPlan.pending, (state) => {
      state.handlingFeesLoading = true;
      state.error = "";
    });
    builder.addCase(
      getChargesByMembershipPlan.fulfilled,
      (state, action: any) => {
        state.handlingFeesLoading = false;
        state.adminCharges = action.payload;
      }
    );
    builder.addCase(getChargesByMembershipPlan.rejected, (state, action) => {
      state.handlingFeesLoading = false;
      state.adminCharges = initialState.adminCharges;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getPromoCodeDetails.pending, (state) => {
      state.promoapplyLoading = true;
      state.error = "";
    });
    builder.addCase(getPromoCodeDetails.fulfilled, (state, action: any) => {
      state.promoapplyLoading = false;
      state.PromoDetails = action.payload;
    });
    builder.addCase(getPromoCodeDetails.rejected, (state, action) => {
      state.promoapplyLoading = false;
      state.PromoDetails = initialState.PromoDetails;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(reedemGiftCodeForBooking.pending, (state) => {
      state.giftcodeapplyLoading = true;
      state.error = "";
    });
    builder.addCase(reedemGiftCodeForBooking.fulfilled, (state) => {
      state.giftcodeapplyLoading = false;
    });
    builder.addCase(reedemGiftCodeForBooking.rejected, (state, action) => {
      state.giftcodeapplyLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(verifyGiftCodeOtp.pending, (state) => {
      state.giftcodeapplyLoading = true;
      state.error = "";
    });
    builder.addCase(verifyGiftCodeOtp.fulfilled, (state) => {
      state.giftcodeapplyLoading = false;
    });
    builder.addCase(verifyGiftCodeOtp.rejected, (state, action) => {
      state.giftcodeapplyLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const {
  settabIndex,
  setPassangerMealIndex,
  setPassangerBaggageIndex,
  setPassangerWheelChairIndex,
  setFlightReviewDetails,
  clearFlightReviewDetails,
} = reviewbookingSlice.actions;
export default reviewbookingSlice.reducer;
